/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/no-unused-vars */

function getPassAwaySupportFunctionsConfig() {
  const pass_away_support__calculation_fee__value = (values, defaultValue) => {
    if (!values.last_month_salary) return 0
    return Math.floor(values.last_month_salary * 3)
  }

  const pass_away_support__actually_approval__value = (values, defaultValue) => {
    if (!values.last_month_salary) return 0
    return Math.floor(values.last_month_salary * 3)
  }

  const onlyOnceSupport = async (context) => {
    const { requestId, requester, queryRunner } = context
    const requestIdValue = requestId !== undefined ? `'${requestId}'` : 'NULL'
    const stringQuery = `
        SELECT
            COUNT(*) as count
        FROM
            bam.claim_requests
        WHERE
            employee_id = '${requester.id}'
            AND type = 'pass_away_support'
            AND (status = 'WAITING' OR status = 'APPROVED')
            AND (${requestIdValue} IS NULL OR id != ${requestIdValue})
        `
    const queryClaimRequest = await queryRunner.query(stringQuery)
    const countClaimRequest = parseInt(queryClaimRequest[0].count)

    return countClaimRequest === 0
  }

  return {
    autoCal: {
      // ...AutoCal,
      pass_away_support__calculation_fee__value,
      pass_away_support__actually_approval__value,
    },
    validate: {
      // ...validate,
      onlyOnceSupport,
    },
  }
}
